import axios from 'axios';

export const appointmentService = {
    /** Create, Edit Appointment */
    createAppointmentService: (body) => axios.post(`/appt`, body, { auth: true }),

    editAppointmentService: (body, id) => axios.patch(`/appt/${id}`, body, { auth: true }),

    addAppointmentLinkService: (body, id) => axios.patch(`/appt/${id}/links`, body, { auth: true }),

    editApptLockUnlockService: ({ list, type, params }) => axios.patch(`/appt/lock/${type}`, list, { auth: true, params: { ...params } }),

    changeApptUnitsService: ({ apptId, type }) =>
        axios.patch(`/appt/${apptId}/round-units`, null, { auth: true, params: { roundType: type } }),
    /** end */

    /** Get Appointment */
    getAppointmentService: (info) => axios.get(`/appt`, { auth: true, params: { ...info } }),

    getCalendarAppointmentService: (info) => axios.get(`/appt/day-contains`, { auth: true, params: { ...info } }),

    getAppointmentByIdService: (id) => axios.get(`/appt/${id}`, { auth: true }),

    getAppointmentDatesByIdService: (id) => axios.get(`/appt/template/${id}/dates`, { auth: true }),

    getAppointmentInformationService: (id) => axios.get(`/appt/${id}/accounting`, { auth: true }),

    getApptAddressesService: (clientId, staffId) => axios.get(`/appt/addresses`, { auth: true, params: { clientId, staffId } }),

    getEligibleChargeRatesService: (staffId, authServiceId, clientId) =>
        axios.get(`/appt/staffs/eligible-charge-rates`, { auth: true, params: { staffId, authServiceId, clientId } }),

    changeCancelReasonReason: (id, reason) => axios.patch(`/appt/${id}/cancellationReason`, null, { auth: true, params: reason }),

    completeMassApptsService: (apptIds, params) => axios.patch(`/appt/mass-render`, apptIds, { auth: true, params: params }),

    getAppointmentSessionService: (id) => axios.get(`/clinical/sessions/appt/${id}`, { auth: true }),

    getApptDataCollectionService: (sessionId) => axios.get(`/clinical/sessions/${sessionId}/appt/dataCollection`, { auth: true }),

    /** end */

    /** Delete Appointment */
    deleteAppointmentService: (id) => axios.delete(`/appt/${id}`, { auth: true }),

    deleteMassApptsService: (apptList, params) =>
        axios.delete('/appt/mass', {
            auth: true,
            data: apptList,
            params: params,
        }),

    /** end */

    /** Appointment Status */
    setAppointmentStatusService: (id, statusName, reason) => {
        if (statusName === 'cancel') {
            return axios.patch(`/appt/${id}/cancel`, reason, { auth: true });
        } else {
            return axios.patch(`/appt/${id}/${statusName}`, null, { auth: true });
        }
    },

    completeApptService: (id, body) => axios.patch(`/appt/${id}/render`, body, { auth: true }),

    // completeApptService: (id, body) => axios.patch(`/appt/${id}/render`, body, { auth: true }),

    removeApptFromBillService: (params) => axios.delete(`/claim/appts`, { auth: true, data: params }),

    removeApptFromInvoiceService: (id, params) => axios.post(`/appt/${id}/remove-from-invoice`, params, { auth: true }),

    unRenderApptService: (id) => axios.patch(`/appt/${id}/unrender`, null, { auth: true }),
    /** end */

    /** Appointment Repeat */

    appointmentRepeatService: (body) => axios.post(`/appt/repeat`, body, { auth: true }),
    /** end */

    appendSignatureTService: (id, signature) => axios.post(`/appt/${id}/signature`, signature, { auth: true }),

    bulkAssignSignatureService: (body) => axios.post(`/appt/bulk-sign`, body, { auth: true }),

    deleteSignatureService: (id, type) => axios.delete(`/appt/${id}/signature`, { auth: true, params: { signatureType: type } }),

    getClientStaffsService: (params) =>
        axios.get(`/appt/staffs/suggestion`, {
            auth: true,
            params: { clientId: params?.clientId, authServiceId: params?.authServiceId },
        }),

    manageNotesService: (id, params) => axios.post(`/appt/${id}/notes`, params, { auth: true }),

    connectReconnectService: (id, params) => axios.patch(`/appt/${id}/template/disconnect`, {}, { auth: true }),

    // connectReconnectService: (id, params) => axios.patch(`/appt/${id}/template/connect`, params, { auth: true }),

    checkApptOverlapping: (params, body) => axios.patch(`/appt/repeat/available`, body, { auth: true, params: params }),

    checkApptUpdateOverlapping: (params) => axios.get('/appt/check/update', { auth: true, params: params }),

    cancelApptService: (id, params) => axios.patch(`/appt/template/${id}/cancel`, null, { auth: true, params: { ...params } }),

    unCancelApptService: (id) => axios.patch(`/appt/${id}/un-cancel`, null, { auth: true }),

    deleteAllApptService: (id, params) => axios.delete(`/appt/template/${id}`, { auth: true, params: { ...params } }),

    getApptStaffsService: () => axios.get(`/appt/staffs/info`, { auth: true }),

    /** Appt Documents */

    uploadService: (file, id) => axios.post(`/appt/${id}/documents`, { ...file }, { auth: true }),

    editService: ({ id, dockId, file }) => axios.patch(`/appt/${id}/documents/${dockId}`, { ...file }, { auth: true }),

    getFilesService: (id) => axios.get(`/appt/${id}/documents`, { auth: true }),

    deleteFilesService: (clientId, id) => axios.delete(`/appt/${clientId}/documents/${id}`, { auth: true }),

    /** End */

    checkFrequencyService: (params) => axios.get(`/appt/check/exceedUnits/v2`, { auth: true, params: params }),

    refreshErrorsService: (id) => axios.patch(`/appt/refreshErrors/${id}`, null, { auth: true }),

    addEditApptNoteService: (id, body) => axios.patch(`/appt/${id}/notes`, body, { auth: true }),

    deleteApptNoteService: (apptId, noteId, type) => axios.delete(`/appt/${apptId}/notes/${noteId}/${type}`, { auth: true }),

    requestApptNoteService: (apptId, message) => axios.patch(`/appt/${apptId}/notes/request-add`, message, { auth: true }),

    remindApptNoteService: (apptId, body) => axios.patch(`/appt/${apptId}/notes/remind`, body, { auth: true }),

    remindApptSignatureService: (body) => axios.post(`/appt/remind-signature`, body, { auth: true }),

    /** Eligibility */

    checkEligibilityService: (id) => axios.get(`/client/${id}/check/eligibility`, { auth: true }),
};
